"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSIGHT_CACHE_SIZE = exports.LOADER_CACHE_SIZE = void 0;
/**
 * Loaders for how many different workspaces will be kept.
 */
exports.LOADER_CACHE_SIZE = 5;
/**
 * How many insights will be kept for each workspace.
 */
exports.INSIGHT_CACHE_SIZE = 20;
//# sourceMappingURL=constants.js.map